import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { skipWhile, takeUntil } from 'rxjs/operators';

// Store
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';
import * as kydEnrollActions from '../../../core/store/programs/kyd/kyd-enroll.actions';
import { KydService } from '../shared/kyd.service';

@Component({
  template: ``,
  standalone: false
})
export class KnowYourDriveSignatureComponent implements OnInit, OnDestroy {
  // Shared subject for completing observables
  private stop$: Subject<void> = new Subject<void>();

  constructor(
    private kydService: KydService,
    private location: Location,
    private pageTitle: PageTitleService,
    private route: ActivatedRoute,
    public spinner: LoadingSpinnerService,
    private store: Store
  ) {}

  ngOnInit() {
    this.spinner.start();
    this.pageTitle.set('KnowYourDrive Signature Confirmation');

    this.route.queryParams.pipe(takeUntil(this.stop$)).subscribe(params => {
      if (params['event'] === 'OnSigningComplete') {
        this.enroll();
      } else {
        this.cancel();
      }
    });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
    this.spinner.stop();
  }

  enroll() {
    const signUps = this.kydService.retrieveSelectedRisks();
    if (!signUps || !signUps.length) {
      this.spinner.stop();
      this.store.dispatch(
        fromRouterActions.Go({
          path: ['/policies/knowyourdrive']
        })
      );
    }

    this.store.dispatch(new kydEnrollActions.EnrollAction(signUps));

    this.store
      .select(fromRoot.getKydEnrollmentConfirmationRefreshComplete)
      .pipe(
        takeUntil(this.stop$),
        skipWhile(refreshComplete => !refreshComplete)
      )
      .subscribe(refreshComplete => {
        this.spinner.stop();
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/policies/knowyourdrive/confirmation']
          })
        );
      });
  }

  cancel() {
    this.spinner.stop();
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/knowyourdrive']
      })
    );
  }
}
